import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaLoaderService {
  private scriptLoaded = false;

  public constructor() {
    this.loadRecaptchaScript();
  }

  private loadRecaptchaScript(): void {
    if (
      environment.recaptchaFlag &&
      !this.scriptLoaded &&
      environment?.recaptchaPublicId &&
      environment.production
    ) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${environment?.recaptchaPublicId || ''}`;
      script.async = true;
      script.defer = true;
      script.onload = (): void => {
        this.scriptLoaded = true;
      };
      document.head.appendChild(script);
    }
  }
}
